import "../css/index.css"

import initHeader from "../../../app/modules/Front/components/Header/Header.js"
import initVideo from "../../../app/modules/Front/components/Video/Video.js"
import initKaraoke from "../../../app/modules/Front/components/Karaoke/Karaoke.js"
import initSpotlight from "../../../app/modules/Front/components/Spotlight/Spotlight.js"
import initTenantsPie from "../../../app/modules/Front/components/TenantsPie/TenantsPie.js"
import initSwiper from "../../../app/modules/Front/components/Swiper/swiper.js"
import initContact from "../../../app/modules/Front/components/ContactToggle/ContactToggle.js"
import initTabs from "../../../app/modules/Front/components/Tabs/Tabs.js"
import initHeroHp from "../../../app/modules/Front/components/HeroHp/HeroHp.js"
import initHeroForm from "../../../app/modules/Front/components/HeroForm/HeroForm.js"
import initPortfolioParks from "../../../app/modules/Front/components/PortfolioParks/PortfolioParks.js"
import initLeadForm from "../../../app/modules/Front/components/LeadForm/LeadForm.js"
import initChart from "../../../app/modules/Front/components/Chart/Chart"
import initIconInfo from "../../../app/modules/Front/components/IconInfo/IconInfo.js"
import initSection from "../../../app/modules/Front/components/Section/Section.js"
import initFlashMessages from "../../../app/modules/Front/components/FlashMessages/FlashMessages.js"
import intiCookiesConsent from "../../../app/modules/Front/components/CookieConsent/CookieConsent.js"
import initScrollToTopButton from "../../../app/modules/Front/components/ScrollToTopButton/ScrollToTopButton"
import initLottie from "./lottie.js"
import initFundSlider from "../../../app/modules/Front/components/FundSlider/FundSlider"
import initAlpine from "./alpine"
import initGallery from "../../../app/modules/Front/components/Gallery/Gallery"
import initInvestmentReturnChart from "../../../app/modules/Front/components/InvestmentReturnChart/InvestmentReturnChart"
import initInvestmentCalculatorCta from "../../../app/modules/Front/components/InvestmentCalculatorCta/InvestmentCalculatorCta"
import initSurveyChartBar from "../../../app/modules/Front/components/SurveyChartBar/SurveyChartBar"
import initButtonDownload from "../../../app/modules/Front/components/ButtonDownload/ButtonDownload"
import initScrollOffsetLinks from "./scrollOffset"
import initMarquee from "./marquee"
import { sendStoredEvent } from "./dataLayer"
import initFormTracking, { sendStoredFormEvents } from "./formTracking"
import { updateUtmHistory } from "./utmHistory"

initAlpine()

// Own listener: a component init throwing below (e.g. initHeader on pages without a header) must not swallow form events
window.addEventListener(`DOMContentLoaded`, () => {
  initFormTracking()
  sendStoredFormEvents()
})

window.addEventListener(`DOMContentLoaded`, () => {
  initHeader()
  initSwiper()
  initVideo()
  initSpotlight()
  initTenantsPie()
  initHeroHp()
  initContact()
  initTabs()
  // initHeroAnim()
  initHeroForm()
  initPortfolioParks()
  initKaraoke()
  initLeadForm()
  initChart()
  initIconInfo()
  initSection()
  intiCookiesConsent()
  initFlashMessages()
  initScrollToTopButton()
  initFundSlider()
  initGallery()
  initInvestmentReturnChart()
  initInvestmentCalculatorCta()
  initSurveyChartBar()
  initScrollOffsetLinks()
  initMarquee()
  initButtonDownload()

  updateUtmHistory()

  // Send data layer event stored in cookies if set
  sendStoredEvent()

  console.log("DOM loaded")
})

window.addEventListener("load", () => {
  initLottie()

  if (window.location.hash) {
    setTimeout(() => {
      const element = document.querySelector(window.location.hash)
      if (element) {
        const scrollPosition =
          element.getBoundingClientRect().top + window.scrollY
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth",
        })
      }
    }, 300)
  }

  console.log("page loaded")
})
